import { UPLOAD_TABS, UploadTab } from './uploadJourneyUtils';

// Card titles/copy for the borrower Data Upload Bank Statement tab (RECUR-28067). Centralised
// here so the same string isn't duplicated across the Bank Statement card's sub-elements
// (conventions rule 6).
export const JOURNEY_CARD_COPY = {
    BANK_STATEMENT: {
        TITLE: 'Upload Bank Statements (Last 12 months)',
        // Not derived from MagicUploadConstants.MIME_TYPES (review comment): that map only lists
        // rar/zip/pdf/octet-stream — it's missing xls/csv/xlsx entirely, and MU mode itself passes
        // acceptOverride: null (useJourneyUploadRouting), i.e. no MIME type is actually enforced
        // by the picker in MU-ON mode. There's no single enforced list to derive this copy from.
        SUBTITLE_MU_ON: 'Upload document (supported file formats: pdf, xls, csv, xlsx, zip).',
        // N5 — MU-OFF still only accepts PDF server-side, so the copy states that truthfully.
        SUBTITLE_MU_OFF: 'Upload document (supported file formats: pdf).',
        FETCH_TITLE: 'Fetch via net-banking',
        FETCH_BUTTON: 'Fetch',
    },
} as const;

export type JourneyTabConfig = {
    /** Untagged-fallback docType applied only if Pandora leaves the file untagged (RECUR-28067 v4). */
    fallbackDocType?: string;
};

// Per-tab Magic Upload routing config (RECUR-28067 review). One entry per UPLOAD_TABS key —
// tabs with no entry here get no special routing behaviour (e.g. no fallbackDocType).
export const JOURNEY_TAB_CONFIG: Partial<Record<UploadTab, JourneyTabConfig>> = {
    // Byte-identical to fl-pojos DocTypesPolus.BANK_STATEMENTS.
    [UPLOAD_TABS.BANK_STATEMENT]: { fallbackDocType: 'Bank Statements' },
};
